module.exports = "https://dashboard.cdn.gifty.nl/6224/images/timer.png?c5b2978d4e5abb08df32210ea966734e";